// export const WEBUI_VERSION="0.2.4";
// next versions:
export const WEBUI_VERSION="0.2.8";
